import { useMemo } from 'react';
import type { Column } from 'react-table';
import type { Statistics } from 'feature-components/reports/item-assessment-report';
import getJuniorAndSeniorScienceColumns from 'feature-components/reports/item-assessment-report/columns/junior-and-senior-science-columns';
import getListeningComprehensionColumns from 'feature-components/reports/item-assessment-report/columns/listening-comprehension-columns';
import getMathematicsColumns from 'feature-components/reports/item-assessment-report/columns/mathematics-columns';
import getPunctuationAndGrammarColumns from 'feature-components/reports/item-assessment-report/columns/punctuation-and-grammar-columns';
import getReadingComprehensionColumns from 'feature-components/reports/item-assessment-report/columns/reading-comprehension-columns';
import getReadingVocabularyColumns from 'feature-components/reports/item-assessment-report/columns/reading-vocabulary-columns';
import getTeReoMāoriColumns from 'feature-components/reports/item-assessment-report/columns/te-reo-māori-columns';
import type { BaseArea } from 'services/assist-api/entities/area/areas';
import type { TestType } from 'services/assist-api/entities/test/tests';

type Props = {
  areaIdentifier: BaseArea['identifier'];
  canHaveStyledQuestionType: boolean;
  showReferenceData: boolean;
  testType: TestType | undefined;
};

export default function useColumns({
  areaIdentifier,
  canHaveStyledQuestionType,
  showReferenceData,
  testType
}: Props): Column<Statistics>[] {
  const columns = useMemo(() => {
    switch (areaIdentifier) {
      case 'math':
        return getMathematicsColumns(canHaveStyledQuestionType, showReferenceData, testType);
      case 'comp':
        return getReadingComprehensionColumns(showReferenceData, testType);
      case 'listening':
        return getListeningComprehensionColumns(showReferenceData, testType);
      case 'vocab':
        return getReadingVocabularyColumns(canHaveStyledQuestionType, showReferenceData, testType);
      case 'pg':
        return getPunctuationAndGrammarColumns(
          canHaveStyledQuestionType,
          showReferenceData,
          testType
        );
      case 'jstwe':
      case 'stwe':
        return getJuniorAndSeniorScienceColumns(
          canHaveStyledQuestionType,
          showReferenceData,
          testType
        );
      case 'trm':
        return getTeReoMāoriColumns(canHaveStyledQuestionType, showReferenceData, testType);
      default:
        return [];
    }
  }, [areaIdentifier, canHaveStyledQuestionType, showReferenceData, testType]);

  return columns;
}
